/**
* Submittals JS
* -----------------------------------------------------------------------------
*
* All the JS for the Submittals component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'submittals',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).on( 'click', '.submittals__file-remove', function( e ) {
        e.preventDefault();
        $( this ).next().prop( 'checked', false );
        $( '#submittals__file-list' ).trigger( 'submit' );
      } );
      $( document ).on( 'submit', '#submittals__file-list', function( e ) {
        $( '.submittals-summary .submittals-loading' ).addClass( 'doing-ajax' );
      } );

      const observer = new MutationObserver( () => {
        const confirmation = document.querySelector( '.ll-submittal-confirmation' );
        if ( confirmation && confirmation.dataset.key ) {
          observer.disconnect();
          setTimeout( () => {
            window.location.href = `/download-submittals/?ll_submittal_download=1&key=${encodeURIComponent( confirmation.dataset.key )}`;
          }, 500 );
        }
      } );

      observer.observe( document.body, {childList: true, subtree: true} );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'submittals', COMPONENT );
} )( app );
